import { KYDScope } from "@common/interfaces/ICognito";
import { ReactNode } from "react";

const ShowIfHasPermission = ({
  permissions = [],
  checkFor,
  children,
}: {
  permissions: KYDScope[];
  checkFor: string | string[];
  children: ReactNode;
}) => {
  const checkValues = Array.isArray(checkFor) ? checkFor : [checkFor];
  if (checkValues.some((val) => permissions.includes(val as KYDScope))) {
    return <>{children}</>;
  }

  return null;
};

export default ShowIfHasPermission;
